import React from 'react';
import { Sample, getSamples } from 'utils/SamplesUtil';
import { useAppContext } from 'hooks/useAppContext';
import { useTheme } from '@material-ui/core';
import SkeletonGrid from 'components/Shared/SkeletonGrid'
import withAppStylesGrid from 'HOCs/withAppStyles';
import withInspectionLink from 'HOCs/withInspectionLink';
import withAttachmentIcons from 'HOCs/withAttachmentsIcons';
import withSelectionGrid from 'HOCs/withSelectionGrid';
import MaterialTable from 'material-table';
import RecieveSampleForm from 'components/Samples/RecieveSampleForm';
import { Alert, AlertTitle } from '@material-ui/lab';
import { useCanDoAction } from 'hooks/useCanDoAction';

export default function PendingGrid({ customFilter }) {

    const columns = Sample.columns.filter(col => col.title !== "Lab Results" && col.title !== "baseSampleId");

    const { selectedProject } = useAppContext(); //Getting the App Context
    const [showAlert, setShowAlert] = React.useState(true);

    const title = "Pending Samples";

    const canUpdate = useCanDoAction('Samples', 'update');

    const theme = useTheme();

    const _getRecords = async (page, pageSize, orderBy, orderDirection, search, _filters) => {
        return await getSamples(page, pageSize, orderBy, orderDirection, { Status: "pending" }, _filters);
    };

    const disabledCriteria = (rowData) => rowData.Description_InspectionStatus !== "Complete";

    let GridWithAppStyles = withAttachmentIcons(
        withInspectionLink(
            withAppStylesGrid(MaterialTable,
                {
                    theme, getRecords: _getRecords, defaultFilters: { projectId: selectedProject, ...customFilter }
                }),
            { inspectionColumnTitle: "Inspection #" }),
    { attachmentColumnTitle: "Attachments" });

    if (canUpdate) {
        GridWithAppStyles = withSelectionGrid(GridWithAppStyles, 
            { theme, ToolbarText: "Recieve Sample(s)", allowSelectMultiple: true, Form: RecieveSampleForm, disabledCriteria }
        )
    };

    return (
        <div>
            {showAlert && canUpdate &&
                <Alert severity="info" style={{ margin: 24 }} onClose={() => { setShowAlert(false) }}>
                    <AlertTitle>Info</AlertTitle>
                Click the checkboxes to recieve samples. Only samples that belong to completed inspections can be recieved.
            </Alert>
            }
            <div style={{ padding: '10px' }}>
                {
                    selectedProject ?
                        <GridWithAppStyles
                            options={{
                                selection: canUpdate,
                                pageSize: 10,
                                pageSizeOptions: [10, 15, 20]
                            }}
                            columns={columns}
                            title={title}
                        />
                        :
                        <SkeletonGrid title={title} />
                }
            </div>
        </div>
    )
}